import { render, staticRenderFns } from "./TabStatus.vue?vue&type=template&id=5d5b8351&scoped=true&"
import script from "./TabStatus.vue?vue&type=script&lang=js&"
export * from "./TabStatus.vue?vue&type=script&lang=js&"
import style0 from "./TabStatus.vue?vue&type=style&index=0&id=5d5b8351&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5b8351",
  null
  
)

export default component.exports